import { UserList } from '../../../components/User';
import { UserType } from '../../../types';

export function VendorUsers() {
  return <UserList type={UserType.Vendor} />;
}
